import React, { FC } from 'react';
import classNames from 'classnames';
import { Slide, ToastContainer as ToastContainerToastify } from 'react-toastify';
import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';
import { useTheme } from '@mui/material/styles';

type ToastContainerProps = {
    className?: string,
    bodyClassName?: string,
    toastClassName?: string,
    style?: object
}

const useStyles = createUseStyles((theme: ThemeProps) => ({
    '@global': {
        '.Toastify__toast--success': {
            backgroundColor: theme.colors.green_transparent,
            borderColor: theme.colors.green,
            borderWidth: theme.spacing(2),
            backdropFilter: 'blur(10px) saturate(150%)',
        },
        '.Toastify__toast--error': {
            backgroundColor: theme.colors.red_transparent,
            borderColor: theme.colors.red,
            borderWidth: theme.spacing(2),
            backdropFilter: 'blur(10px) saturate(150%)',
        },
        '.Toastify__toast-icon': {
            display: 'none',
        },
    },
    body: {
        fontFamily: theme.font.secondary,
        fontSize: 16,
        lineHeight: 1.5,
        color: theme.colors.white,
    },
    wrapper: {
        bottom: 0,
        right: theme.spacing(4),
        width: 470,
        maxWidth: 470,
    },
    toast: {
        minHeight: 48,
        borderRadius: theme.radius,
        marginBottom: theme.spacing(4),
        padding: theme.spacing(3),
    },
}))

export const ToastContainer: FC<ToastContainerProps> = props => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const { bodyClassName, toastClassName, className, ...rest } = props;

    return (
        <ToastContainerToastify
            position="bottom-right"
            bodyClassName={classNames(styles.body, bodyClassName)}
            toastClassName={classNames(styles.toast, toastClassName)}
            className={classNames(styles.wrapper, className)}
            hideProgressBar={false}
            autoClose={5000}
            closeButton={false}
            transition={Slide}
            closeOnClick
            stacked
            {...rest}
        />
    )
}
